import { FC, PropsWithChildren } from 'react';
import { Box, GlobalStyles, ThemeProvider } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';

import {
	Container,
	ContentLayer,
	ROTATING_GRADIENT_GLOBAL_STYLES,
	RotatingGradientLayer,
} from './ServiceCardLayout.styles';

interface IServiceCardLayoutProps extends PropsWithChildren {
	isSelected?: boolean;
	isSearching?: boolean;
	disableBorder?: boolean;
	disableInteraction?: boolean;
	onClick?: () => void;
	testId?: string;
}

export const ServiceCardLayout: FC<IServiceCardLayoutProps> = ({
	children,
	isSelected = false,
	isSearching = false,
	disableBorder = false,
	disableInteraction = false,
	onClick,
	testId,
}) => {
	const shouldShowAnimatedBorder = isSelected && isSearching;

	return (
		<ThemeProvider theme={passengerThemeV2}>
			{shouldShowAnimatedBorder ? (
				<>
					<GlobalStyles styles={ROTATING_GRADIENT_GLOBAL_STYLES} />
					<Box
						onClick={onClick}
						sx={{ position: 'relative' }}
						data-testid={testId}
					>
						<RotatingGradientLayer />
						<ContentLayer>{children}</ContentLayer>
					</Box>
				</>
			) : (
				<Container
					selected={isSelected}
					disableBorder={disableBorder}
					disableInteraction={disableInteraction}
					onClick={onClick}
					data-testid={testId}
				>
					{children}
				</Container>
			)}
		</ThemeProvider>
	);
};
